import React from "react";
import { useRouter } from "next/router";
import { getNextAndPreviousRoutes } from "utils/nav";
import classnames from "classnames";
import Link from "next/link";
import { getIconForUID } from "components/FormerEditor/utils";
import { COLORS } from "utils/styles";

const DEFAULT_CLASSES = {
  container: "w-100 flex flex-row justify-between",
  navigator: "flex flex-column pointer w-100 items-start",
  directionLabel: "f6 black-70",
  parentLabel: "fw5 f4 pt2",
  nextWrapper: "flex flex-row items-center pt2 link__decoration--hover",
  nextLabel: "f5 fw5 color-primary"
};
const DEFAULT_ICON_SIZE = 18;

const NextPrevNav = ({ config, size = DEFAULT_ICON_SIZE, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const router = useRouter();
  const asPath = router ? router.asPath : "";

  const nextAndPrevious = getNextAndPreviousRoutes({
    asPath,
    config
  });

  const RightArrow = getIconForUID("rightArrow");
  const LeftArrow = getIconForUID("back");
  const hasPrevAndNext = Boolean(nextAndPrevious.prev && nextAndPrevious.next);
  return (
    <div
      className={classnames(classes.container, {
        "justify-end": !hasPrevAndNext
      })}
    >
      {nextAndPrevious.prev && (
        <Link as={nextAndPrevious.prev.as} href={nextAndPrevious.prev.href}>
          <div className={`${classes.navigator} items-start`}>
            <div className={classes.directionLabel}>Previous</div>
            <div className={classes.parentLabel}>
              {nextAndPrevious.prev.parent ? nextAndPrevious.prev.parent : " "}
            </div>
            <div className={classes.nextWrapper}>
              <LeftArrow color={COLORS.blue} size={18} />
              <div className={classes.nextLabel}>
                {nextAndPrevious.prev.label}
              </div>
            </div>
          </div>
        </Link>
      )}
      {nextAndPrevious.next && (
        <Link as={nextAndPrevious.next.as} href={nextAndPrevious.next.href}>
          <div className={`${classes.navigator} items-end`}>
            <div className={classes.directionLabel}>Next</div>
            <div className={classes.parentLabel}>
              {nextAndPrevious.next.parent ? nextAndPrevious.next.parent : " "}
            </div>
            <div className={classes.nextWrapper}>
              <div className={classes.nextLabel}>
                {nextAndPrevious.next.label}
              </div>
              <RightArrow color={COLORS.blue} size={18} />
            </div>
          </div>
        </Link>
      )}
    </div>
  );
};

export default NextPrevNav;
